import { ExclamationCircleOutlined } from '@ant-design/icons';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import Modal from '@deprecated-ui/common/Modal';
import color from '@deprecated-ui/_style/color';
import tradingOperationStore from 'lib/stores/tradingOperation';
import { iModal } from 'features/trade/components/types';
import { FC, MouseEventHandler } from 'react';
import { withMaintenanceGuard } from 'global/Securities/utils/maintenance';
import shallow from 'zustand/shallow';
import { AlertCancelButton } from 'features/trade/components/styled';
import { CancelOrderParams } from 'global/Securities/types/api/orderDetail';
import tradingDataStore from 'lib/stores/tradingData';

interface ICancelModal extends iModal {
  data: CancelOrderParams;
}

const CancelModal: FC<ICancelModal> = ({
  data,
  visible,
  onCancel = () => {},
}) => {
  const { orderId, symbol } = data;

  const { orderHistory } = tradingDataStore.getState();
  const order = orderHistory?.data?.find((o) => o.orderid === orderId);

  const isDayTrade = order.day_trade_is_day_trade;
  const isTrailingStop = order.trailing_stop?.id;
  const {
    postTradeCancelData: { isLoading },
    postDayTradeCancelData: { isLoading: isDayTradeLoading },
  } = tradingOperationStore();

  const { postTradeCancel, postDayTradeCancel, deleteTrailingStop } =
    tradingOperationStore(
      (s) => ({
        postTradeCancel: s.postTradeCancel,
        postDayTradeCancel: s.postDayTradeCancel,
        deleteTrailingStop: s.deleteTrailingStop,
      }),
      shallow,
    );

  const handleCancelOrderRequest = async () => {
    if (isTrailingStop) {
      await deleteTrailingStop(orderId);
      return;
    }

    if (isDayTrade) {
      await postDayTradeCancel(orderId);
      return;
    }

    await postTradeCancel({
      orderkey: `W-WITHDRAW-${Date.now()}`,
      orderid: orderId,
      symbol,
      isRealTrading: true,
    });
  };

  const handleCancelOrderClick: MouseEventHandler<HTMLButtonElement> = (
    event,
  ) => {
    event.stopPropagation();

    withMaintenanceGuard(async () => {
      await handleCancelOrderRequest();

      onCancel?.();
    });
  };

  return (
    <Modal
      visible={visible}
      closable
      width="416px"
      centered
      onCancel={onCancel}
    >
      <Flex direction="column" padding="20px">
        <Flex justify="center">
          <ExclamationCircleOutlined
            style={{ fontSize: '24px', color: '#FCCC54' }}
          />
          {/* @ts-expect-error */}
          <Text ml="20px" mt="4px" family="bold" color="#000000A6">
            Do you want to cancel this order ?
          </Text>
        </Flex>
        {/* @ts-expect-error */}
        <Flex mt="40px" width="100%" justify="right">
          <AlertCancelButton onClick={onCancel}>
            <Text size="14px">Cancel</Text>
          </AlertCancelButton>
          <Button
            type="primary"
            onClick={handleCancelOrderClick}
            loading={isLoading ?? isDayTradeLoading}
            // @ts-expect-error
            ml="10px"
            height="35px"
          >
            <Text size="14px" color={color.light}>
              OK
            </Text>
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default CancelModal;
